export default __webpack_public_path__ + "static/media/notification.dbf053c5.mp3";